import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { FC } from 'react';
import PeCompanyPreviewSection from './info/sections/PeCompanyPreviewSection';
import PeCompanyInfo from './info/PeCompanyInfo';
import { useTranslation } from 'react-i18next';
import PeArticles from './articles/PeArticles';
import PeOrderBook from './orderBook/PeOrderBook';
import PeDetailOrders from './PeDetailOrders';
import PeDetailAssets from './assets/PeDetailAssets';

interface Props {
  assetId: ID;
  company: PeCompanyDetail;
}

const PeCompanyDataLoaded: FC<Props> = ({ company, assetId }) => {
  const { t } = useTranslation();

  return (
    <>
      <PeCompanyPreviewSection company={company} />
      <Tabs>
        <TabList>
          <Tab>{t('peTabInfo')}</Tab>
          <Tab>{t('peTabOrderBook')}</Tab>
          <Tab>{t('peTabNews')}</Tab>
          <Tab>{t('ordersLabel')}</Tab>
          <Tab>{t('myDealsLabel')}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel p="0" pt="20px">
            <PeCompanyInfo company={company} />
          </TabPanel>
          <TabPanel p="0" pt="20px">
            <PeOrderBook companyId={company.id} />
          </TabPanel>
          <TabPanel p="0" pt="20px">
            <PeArticles articles={company.articles} />
          </TabPanel>
          <TabPanel p="0" pt="20px">
            <PeDetailOrders
              orders={company.investorsOrders}
              assetId={assetId}
            />
          </TabPanel>
          <TabPanel p="0" pt="20px">
            <PeDetailAssets company={company} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default PeCompanyDataLoaded;
